import React, { useEffect, Fragment } from 'react';
import { observer, useObserver } from 'mobx-react-lite';

/* packages */
import useForm from '../../util-hook-useform';
import useSuggest from '../../util-hook-usesuggest';
import validation from '../../util-inputs-validation';
import Input from '../../util-mui-inputs';
import { Inputs, Buttons } from '../../util-atomic';
import { LocalStorage } from '../../lib-atomic-functions';
/* packages */

/* module */
import StepsLoader from '../loader/steps';
import ProductInfo from '../../app-module-product-detail/info';
/* module */

/* functions */
import { ProductCat1List, ProductCat2List, ProductCat3List, ProductCat4List } from '../../app-module-product-container/functions';
/* functions */

import CONFIG from '../config';

const Index = observer(({ handleNext, handleBack, handleReset, handleCollection, collection }) => {

  const { login } = LocalStorage.getLS();
  const { token } = login;

  const formObjects = CONFIG.application.fees.objects;

  /* states */
  /* product: cards and carriers */
  const { productCat1ListContext, productCat1ListMethod, productCat1ListData } = ProductCat1List({CONFIG, token});
  const { productCat4ListContext, productCat4ListMethod, productCat4ListData } = ProductCat4List({CONFIG, token});

  useEffect(() => {
    productCat1ListMethod();
    productCat4ListMethod();
  }, []);
  /* states */

  const productSource = (productCat1ListData && productCat4ListData) ? [...productCat1ListData.products, ...productCat4ListData.products] : false;

  const productTemplate = (data) => {
    return <ProductInfo {...data} />
  }

  const productNext = () => {
    handleNext();
  }

  const productBack = () => {
    handleBack();
  }

  const productValidate = () => {
    //handleNext();
    const { suggestion } = JSON.parse(selectedProduct);
    const quantity = 1;
    const total = values.value * 1;
    const newProduct = {...values, ...suggestion, quantity, total}
    handleCollection('fees', newProduct);
    values.value = "";
    values.quantity = "";
    values.product = "";
    setSelectedProduct(false);
    setIsSelectedProduct(false);
    setSelectedValue("");
  }

  const productAdd = (data) => {
    if (!data) return handleValue('product', '');
    const { suggestion } = JSON.parse(data);
    return handleValue('product',  String(suggestion.productId));
  }

  const [
    onLoadCompany,
    onResetProduct,
    isSelectedProduct,
    selectedProduct,
    suggestionProduct,
    setSelectedProduct,
    setIsSelectedProduct,
    setSelectedValue,
  ] = useSuggest(productAdd, productTemplate, productSource, 'description');

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleValue,
  } = useForm(productValidate, validation, formObjects, false);

  /* form: step 3 */
  const productFormObject = { ...formObjects.product, errors: errors.product, value: values.product, handleChange: handleChange };
  const valueFormObject = { ...formObjects.value, errors: errors.value, value: values.value, onChange: handleChange };
  //const quantityFormObject = { ...formObjects.quantity, errors: errors.quantity, value: values.quantity, onChange: handleChange };
  /* form: step 3 */

  if (!productSource) return <StepsLoader />

  const isProductCollection = collection.fees.length > 0 ? true : false;

  return <form onSubmit={handleSubmit} noValidate>
    <p>Select courier, service and admin fees</p>
    <Input.Suggest {...productFormObject} suggestionProps={suggestionProduct} isSelected={isSelectedProduct} selectedValue={selectedProduct} displayTemplate={productTemplate}>
      <Buttons.PrimarySmall onClick={onResetProduct}>Remove</Buttons.PrimarySmall>
    </Input.Suggest>
    <hr />
    <Inputs.Text {...valueFormObject} />

    <br/>
    <Buttons.Normal>Add fee</Buttons.Normal>
    <br/>
    <hr />
    <Buttons.DefaultSmallNon onClick={productBack}>Back</Buttons.DefaultSmallNon>
    <Buttons.DefaultSmallNon onClick={productNext}>Next</Buttons.DefaultSmallNon>
  </form>

});

export default Index;

// <Inputs.Hidden {...quantityFormObject} />
